firebird.factory('analyticsWrapperService', [
    '$rootScope',
    '$analytics',
    '$timeout',
    '$interval',
    '$window',
    'logService',
    'phoneConferenceService',
    'subscriptionService',
    'browserUpgradedService',
    'brandingService',
    'configService',
    function (
        $rootScope,
        $analytics,
        $timeout,
        $interval,
        $window,
        logService,
        phoneConferenceService,
        subscriptionService,
        browserUpgradedService,
        brandingService,
        configService
    ) {
        const logger = logService.createLoggerWithSource('analyticsWrapperService');

        let rootSubscription = undefined,
            locationHost = undefined,
            environment = 'unknown';

        var hasloadedHeapAnalyticsSnippet = false,
            hasLoadedIntercomSnippet = false,
            meetingCode = 0,
            meetingType = '',
            isHostAttendee = false,
            service = {
                // The following commented out functions are supported by
                // $analytics (angulartics), but have not been wrapped here
                // pageTrack                        : pageTrack,
                // exceptionTrack                   : exceptionTrack,
                // setAlias                         : setAlias,
                // setUserPropertiesOnce            : setUserPropertiesOnce,
                // setSuperProperties               : setSuperProperties,
                // setSuperPropertiesOnce           : setSuperPropertiesOnce,
                // userTiming                       : userTiming,

                eventTrack: eventTrack,
                setUsername: setUsername,
                loadPendoAnalytics: loadPendoAnalytics,
                initializePendo: initializePendo,
                setPendoInitMetadata,
                updatePendoIdentity: updatePendoIdentity,
                setPendoAvailable: setPendoAvailable,
                getUsername: getUsername,
                resetUsername: resetUsername,
                setUserProperties: setUserProperties,
                setMeetingType: setMeetingType,

                // Heap analytics
                loadStagingHeapSnippet: loadStagingHeapSnippet,
                loadHeapSnippet: loadHeapSnippet,
                loadProductionHeapSnippet: loadProductionHeapSnippet,

                initNonMobileAnalytics: initNonMobileAnalytics,
                initMobileAnalytics: initMobileAnalytics,
                storeMeetingCode: storeMeetingCode,
                startAttendanceTimer: startAttendanceTimer,
                loadProductionGoogleAnalyticsSnippet: loadProductionGoogleAnalyticsSnippet,

                hostMeetingDuration: 0, //in 30 minute intervals (0 = <30min, 1 = 31min-60min, etc.)
                hostMeetingDurationTimer: null,
                pendoAvailable: false,
                startHostMeetingDurationTimer: startHostMeetingDurationTimer,
                cancelHostMeetingDurationTimer: cancelHostMeetingDurationTimer,
                submitMeetingDuration: submitMeetingDuration,

                setIsHost: setIsHost,
                getEnvironment,
                sendAnalyticsToFireflow: true,
                initConfig: initConfig
            };

        let pendoVisitorPayload = { id: brandingService.getPendoAnonId() };
        let pendoAccountPayload = undefined;

        initSubscriptions();

        return service;

        ////////////////////////

        // The following commented out functions are supported by
        // $analytics (angulartics), but have not been wrapped here
        // function pageTrack
        // function exceptionTrack
        // function setAlias
        // function setUserPropertiesOnce
        // function setSuperProperties
        // function setSuperPropertiesOnce
        // function userTiming

        // extracted to analytics.service.ts
        function eventTrack(action, properties) {
            var event = 'FB ' + action;
            var prop = properties || {};

            if (prop.sfuEvent) {
                event = 'SFU - ' + event;
            }

            if (meetingType) {
                prop.meetingType = meetingType;
            }

            prop.meetingCode = meetingCode;

            var phoneData = phoneConferenceService.getPhoneData();
            if (properties && properties.category === 'verto' && phoneData) {
                prop.fsServer = phoneData.server;
            }

            try {
                if (hasloadedHeapAnalyticsSnippet || window?.pendo?.track) {
                    $analytics.eventTrack(event, prop);
                }
            } catch (error) {
                logger.error('eventTrack', 'error', event, error);
            }
            // 'KM' refers to the analytics platform KissMetrics that we no longer use.
            // 'KM' was left here so all operational alerts that are based on
            // logged analytics events, if there are any, don't break.
            if (!service.sendAnalyticsToFireflow) {
                logger.info('KM Event', event);
            } else {
                logger.info('KM Event', event, prop);
                // Log msgflow events for analytics
                if (prop.msgflow) {
                    // Do not log sfuEvent, meetingCode, meetingType and log action as detail
                    const {
                        msgflow,
                        sfuEvent: _sfuEvent,
                        meetingCode: _meetingCode,
                        meetingType: _meetingType,
                        ...otherProps
                    } = { ...(properties || {}), detail: action };
                    $rootScope.$broadcast('send-msgflow-event', { name: msgflow, data: otherProps });
                }
            }
        }

        function storeMeetingCode(newMeetingCode) {
            meetingCode = newMeetingCode;
        }

        function setUsername(userId) {
            try {
                $analytics.setUsername(userId);
            } catch (err) {
                logger.error('setUsername', 'Unable to set user name using $analytics', err);
            }

            // angulartics does not call heap.identify properly
            try {
                if ($window.heap && $window.heap.identify) {
                    $window.heap.identify(userId);
                }
            } catch (err) {
                logger.error('setUsername', 'Unable to call identify on heap', err);
            }
        }

        function getUsername() {
            return $window.heap ? $window.heap.identity : '';
        }

        function setUserProperties(properties) {
            try {
                $analytics.setUserProperties(properties);
            } catch (err) {
                logger.error('setUserProperties', 'Unable to set user properties using $analytics', err);
            }
        }

        function setMeetingType(newMeetingType) {
            meetingType = newMeetingType;
        }

        function resetUsername() {
            try {
                $analytics.setUsername('');
            } catch (err) {
                logger.error('resetUsername', 'Unable to reset user name using $analytics', err);
            }

            // angulartics does not call heap.resetIdentity at all
            try {
                if ($window.heap && $window.heap.resetIdentity) {
                    $window.heap.resetIdentity();
                }
            } catch (err) {
                logger.error('resetUsername', 'Unable to call reset identity on heap', err);
            }
        }

        function loadStagingHeapSnippet() {
            service.loadHeapSnippet('1313292769');
        }

        function loadProductionHeapSnippet() {
            service.loadHeapSnippet('2245772222');
        }

        function loadHeapSnippet(appId) {
            if (hasloadedHeapAnalyticsSnippet === false) {
                try {
                    $window.heap.load(appId, { forceSSL: true });

                    hasloadedHeapAnalyticsSnippet = true;
                    logger.info('Successfully loaded Heap Snippet');
                } catch (e) {
                    logger.error('loadHeapSnippet', 'Unable to load Heap Snippet', e);
                }
            }
        }

        function loadProductionGoogleAnalyticsSnippet() {
            logger.info('Loading Google Analytics script');
            try {
                $window.ga('create', 'UA-12716142-8', 'auto');
            } catch (e) {
                logger.error('loadProductionGoogleAnalyticsSnippet', 'Unable to load Google Analytics', e);
            }
        }

        function initNonMobileAnalytics(info) {
            // Load non-mobile analytics

            if (service.getEnvironment() === 'prod') {
                // Load production snippets
                service.loadProductionGoogleAnalyticsSnippet();
                if (info && (info.isPLR || info.shouldLoadHeap)) {
                    service.loadProductionHeapSnippet();
                }
            } else {
                // No Google Analytics for Staging Environment

                // Load QA Heap analytics snippet
                if (info && info.shouldLoadHeap) {
                    service.loadStagingHeapSnippet();
                }
            }
        }

        function initMobileAnalytics() {
            // Load mobile analytics based on environment

            if (service.getEnvironment() === 'prod') {
                // Load production snippet
                service.loadProductionHeapSnippet();
            } else {
                // Load QA Heap analytics snippet
                service.loadStagingHeapSnippet();
            }
        }

        function startAttendanceTimer() {
            var minute = 1000 * 60;

            // 'KM' refers to the analytics platform KissMetrics that we no longer use.
            // 'KM' was left here so all operational alerts that are based on
            // logged analytics events, if there are any, don't break.
            logger.info('Starting KM attendance timer');

            $timeout(function () {
                service.eventTrack('meeting - 1 minute attended');
            }, minute);

            $timeout(function () {
                service.eventTrack('meeting - 5 minutes attended');
            }, minute * 5);

            $timeout(function () {
                service.eventTrack('meeting - 10 minutes attended');
            }, minute * 10);

            $timeout(function () {
                service.eventTrack('meeting - 20 minutes attended');
            }, minute * 20);

            $timeout(function () {
                service.eventTrack('meeting - 30 minutes attended');
            }, minute * 30);

            $timeout(function () {
                service.eventTrack('meeting - 60 minutes attended');
            }, minute * 60);
        }

        function startHostMeetingDurationTimer() {
            logger.info('Starting Host Meeting Duration timer');

            //Hacky way to get duration of a meeting onto Heap -- send it from host only, when host leaves or exits a meeting
            service.hostMeetingDurationTimer = $interval(function () {
                service.hostMeetingDuration++;

                //Meeting has reached >120 minutes
                if (service.hostMeetingDuration === 4) {
                    service.cancelHostMeetingDurationTimer();
                }
            }, 30 * 1000 * 60); //every 30 min
        }

        function cancelHostMeetingDurationTimer() {
            if (service.hostMeetingDurationTimer) {
                logger.info('Cancelling Host Meeting Duration timer');
                $interval.cancel(service.hostMeetingDurationTimer);
                service.hostMeetingDurationTimer = null;
            }
        }

        function submitMeetingDuration() {
            switch (service.hostMeetingDuration) {
                case 0:
                    service.eventTrack('meeting - duration - 30 minutes or less');
                    break;
                case 1:
                    service.eventTrack('meeting - duration - 31-60 minutes');
                    break;
                case 2:
                    service.eventTrack('meeting - duration - 61-90 minutes');
                    break;
                case 3:
                    service.eventTrack('meeting - duration - 91-120 minutes');
                    break;
                case 4:
                    service.eventTrack('meeting - duration - over 120 minutes');
                    break;
            }
        }

        function setPendoAvailable(value) {
            service.pendoAvailable = value;
            // by checking pendo.track we can already make sure that there will be no double load and initialization
            if (service.pendoAvailable === true && !window?.pendo?.track) {
                service.loadPendoAnalytics();
                service.initializePendo();
            }
        }

        function loadPendoAnalytics() {
            logger.info('Loading Pendo Analytics');
            if (window?.pendo?.load) {
                window.pendo.load('80f7e419-8790-4c19-444b-92a159017f44');
                logger.info('Pendo Analytics loaded');
                return;
            }

            if (window?.pendo?.track) {
                logger.warn('loadPendoAnalytics', 'Pendo already loaded, for re-initialization reload page');
                return;
            }

            logger.error('loadPendoAnalytics', 'Unable to load Pendo');
        }

        function initializePendo() {
            if (window?.pendo?.initialize) {
                window.pendo.initialize({
                    visitor: { ...pendoVisitorPayload },
                    account: pendoAccountPayload
                });
            }
        }

        function updatePendoIdentity(key, value) {
            pendoVisitorPayload[`am_${key}`] = value;
            if (window?.pendo?.identify) {
                window.pendo.identify({
                    visitor: { ...pendoVisitorPayload },
                    account: pendoAccountPayload
                });
            }
        }

        function setPendoInitMetadata(userIdentity, accountIdentity, language) {
            pendoAccountPayload = {
                id: accountIdentity
            };
            pendoVisitorPayload.id = userIdentity;
            pendoVisitorPayload['am_language'] = language;
        }

        function setIsHost(isHost) {
            isHostAttendee = isHost;
        }

        function getEnvironment() {
            return environment;
        }

        function initSubscriptions() {
            rootSubscription = subscriptionService.createSubscription();
            rootSubscription.add(
                browserUpgradedService.appEnv$.subscribe(next => {
                    environment = next;
                })
            );
        }

        function initConfig() {
            service.sendAnalyticsToFireflow = configService.getValue('sendAnalyticsToFireflow') !== 'false';
        }
    }
]);
